import React, { useState, useEffect } from "react";

function SidebarItem({ item, onSuperAdminClick, loggedIn }) {
  const isSuperAdmin = item.title === "Super Admin";
  const [open, setOpen] = useState(false);

  // Auto-expand Super Admin after login
  useEffect(() => {
    if (isSuperAdmin && loggedIn) {
      setOpen(true);  // Ensure "Super Admin" is expanded after login
    }
  }, [loggedIn, isSuperAdmin]);

  const handleClick = () => {
    if (item.childrens) {
      if (isSuperAdmin && !loggedIn) {
        onSuperAdminClick();
      } else {
        setOpen(!open);
      }
    }
  };

  if (item.childrens) {
    return (
      <div className={open ? "sidebar-item open" : "sidebar-item"}>
        <div className="sidebar-title" onClick={handleClick}>
          <span className="sidebar-titile-elmt">{item.title}</span>
          <svg className="toggle-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
          </svg>
        </div>
        <div className="sidebar-content">
          {item.childrens.map((child, index) => (
            <SidebarItem
              key={index}
              item={child}
              loggedIn={loggedIn}
              onSuperAdminClick={onSuperAdminClick}
            />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <a href={item.path || "#"} className="sidebar-item plain">
        <span className="sidebar-titile-elmt">{item.title}</span>
      </a>
    );
  }
}

export default SidebarItem;
